import { Severity } from '@/types/validation';
import { Stack, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import ErrorIcon from './ErrorIcon';

type ErrorBadgeProps = {
  severity: Severity;
  label?: string;
  rounded?: boolean;
  outlined?: boolean;
};

const ErrorBadge: FC<ErrorBadgeProps> = (props) => {
  const getColor = () => {
    switch (props.severity) {
      case 'warning':
        return theme.palette.mode === 'dark' ? theme.palette.warning.dark : theme.palette.warning.light;
      case 'info':
        return theme.palette.mode === 'dark' ? theme.palette.info.dark : theme.palette.info.light;
      case 'error':
      default:
        return theme.palette.mode === 'dark' ? theme.palette.error.dark : theme.palette.error.light;
    }
  };

  const theme = useTheme();
  return (
    <Stack
      height='100%'
      direction='row'
      alignItems='center'
      bgcolor={getColor()}
      color={theme.palette.common.white}
      gap={0.5}
      {...((props.label && {
        minWidth: theme.spacing(6),
        pl: 0.5,
        pr: 0.5
      }) || { p: 0.25 })}
      sx={{
        ...(props.rounded && {
          borderRadius: theme.spacing(6)
        })
      }}
    >
      <ErrorIcon severity={props.severity} outlined={props.outlined?.toString()} fontSize='small' />
      {props.label && <Typography variant='caption'>{props.label}</Typography>}
    </Stack>
  );
};

export default ErrorBadge;
